import { Component, inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { LockerSpirit } from '../../../../../core/models/lockerSpirit.model';
import { ApiService } from '../../../../../core/services/api.service';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { MatOptionModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';

const materialModules = [
  MatIconModule,
  MatDialogModule,
  MatButtonModule,
  MatFormFieldModule,
  MatSelectModule,
  MatInputModule,
  ReactiveFormsModule,
  MatOptionModule
]

@Component({
  selector: 'app-spirit-detail-locker-consumption',
  standalone: true,
  imports: [TranslateModule, ...materialModules],
  templateUrl: './spirit-detail-locker-consumption.component.html',
  styleUrls: ['./spirit-detail-locker-consumption.component.scss']
})
export class SpiritDetailLockerConsumptionComponent implements OnInit {

  api = inject(ApiService);

  lockerSpirit: LockerSpirit | null = null;
  lockerUser: any = null;

  statusOptions = {
    partial: 'partial',
    finished: 'finished'
  }

  form = new FormGroup({
    quantity: new FormControl(1, [Validators.required]),
    status: new FormControl(this.statusOptions.partial, [Validators.required]),
    remainingQuantity: new FormControl(50, [Validators.max(100), Validators.min(0)]),
    notes: new FormControl('')
  });

  constructor(
    private dialogRef: MatDialogRef<SpiritDetailLockerConsumptionComponent>
  ) { }

  ngOnInit(): void {
    const control = this.form.get('quantity');
    if (control) {
      control.setValidators([
        Validators.required,
        Validators.min(1),
        Validators.max(this.lockerSpirit!.quantity)
      ]);

      control.updateValueAndValidity();
    }
  }

  saveConsumption() {
    if (!this.form.valid) {
      this.form.markAllAsTouched();
      return;
    }

    const body: any = this.form.value;
    body.spiritUuid = this.lockerSpirit!.spirit.uuid;

    if (body.status == this.statusOptions.finished) {
      body.remainingQuantity = 0;
    }

    this.api.saveLockerConsumption(this.lockerUser.code, body).subscribe(
      data => {
        if (data.success) {
          this.dialogRef.close(data.consumption);
        }
      }
    );
  }

  close() {
    this.dialogRef.close();
  }

}
